module.exports = "<park-schedule-form [formMode]=\"'edit'\" [park]=\"park\" [schedule]=\"schedule\" [scheduleId]=\"scheduleId\"></park-schedule-form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/schedules/park-schedule-item/park-schedule-item.html
// module id = ./src/app/dashboard/parks/park/schedules/park-schedule-item/park-schedule-item.html
// module chunks = main